module.exports = __webpack_public_path__ + "resources/img/bg_banner_inquiry_m_v2.f54631ad8ac4ed69673070af4f0b2626.png";